import _objectWithoutPropertiesLoose from "@babel/runtime-corejs2/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime-corejs2/helpers/esm/inheritsLoose";
import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/es/Dropdown';
import splitComponentProps from 'react-bootstrap/es/utils/splitComponentProps';

var propTypes = _extends({}, Dropdown.propTypes, {
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  title: PropTypes.node.isRequired,
  noCaret: PropTypes.bool,
  icon: PropTypes.string, // Neue Prop für das Icon
  children: PropTypes.node
});

var DropdownButtonCustom =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(DropdownButtonCustom, _React$Component);

    function DropdownButtonCustom() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = DropdownButtonCustom.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        icon = _this$props.icon, // Icon aus den Props holen
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["bsSize", "bsStyle", "title", "icon", "children"]);

      var _splitComponentProps = splitComponentProps(props, Dropdown.ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

      return React.createElement(Dropdown, _extends({}, dropdownProps, {
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        React.createElement(Dropdown.Toggle, _extends({}, toggleProps, {
            bsSize: bsSize,
            bsStyle: bsStyle
          }),
          icon ? React.createElement("i", { className: icon, style: { marginRight: 5 } }) : null,
          React.createElement("span", null, title)
        ),
        React.createElement(Dropdown.Menu, null, children)
      );
    };

    return DropdownButtonCustom;
  }(React.Component);

DropdownButtonCustom.propTypes = propTypes;
export default DropdownButtonCustom;
